<template>
	<div>
		<label v-if="label" class="form-control-label">{{ label }}</label>
		<div class="form-control-auto form-control">
			<div v-for="(option, index) in options" :key="index">
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						:name="groupName"
						v-model="model"
						:disabled="disabled"
						:value="option.value"
						:id="optionId(index)"
					/>
					<label class="form-check-label" :for="optionId(index)">{{
						option.name
					}}</label>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'button-radio-group',
	props: {
		options: {
			type: Array,
			description:
				'Radio options. Should be an array of objects {value: "", name: ""}',
			default: () => [],
		},
		disabled: {
			type: Boolean,
		},
		value: {
			type: String,
			description: 'Radio value',
		},
		buttonClasses: {
			type: [String, Object],
			description: 'Inner button css classes',
		},
		label: {
			type: String,
			default: null,
		},
	},
	model: {
		prop: 'value',
		event: 'change',
	},
	computed: {
		// Unique per component instance so two radio groups on the same page
		// don't share one native radio group (and clear each other's selection).
		groupName() {
			return `formRadioGroup-${this._uid}`;
		},
		model: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit('change', val);
			},
		},
	},
	methods: {
		optionId(index) {
			return `${this.groupName}-${index}`;
		},
	},
};
</script>
<style></style>
